import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface Holiday {
  _id: string;
  org: string;
  title: string;
  date: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export type HolidaysResponse = {
  success: boolean;
  message: string;
  data: Holiday[];
};

const fetchHolidays = async (): Promise<HolidaysResponse> =>
  (await customAxios.get<HolidaysResponse>("/holidays")).data;

export const useGetHolidays = () =>
  useQuery<HolidaysResponse, AxiosError>(["holidays"], fetchHolidays, {
    onError: (error) =>
      showNotification({
        title: "Error Loading Holidays",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to load holidays",
        color: "red",
      }),
    staleTime: 1000 * 60 * 5,
    retry: 1,
    refetchOnMount: "always",
  });
